export class GetUserPassSubscriptionByDmPassSubscriptionIdRequestDto {
  dmPassSubscriptionId: string;
  active: boolean;
}
